// extracted by mini-css-extract-plugin
export default {"articles_management_container":"articles-tab_articles_management_container__h69Rl"};